export default __webpack_public_path__ + "static/media/reporthelp-detailE-mobile.4d69d291.png";